export default {
  low: 'Düşük',
  middle: 'Orta',
  high: 'Yüksek',
  critical: 'Kritik',
};
